import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

export const initialState = {
  model: [],
  meta: {},
};

const entityJurisdictionsList = createSlice({
  name: 'entityJurisdictionsList',
  initialState,
  reducers: {
    reset: () => initialState,
    request: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload?.result;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
  },
});

export const {
  reset: entityJurisdictionsListReset,
  request: entityJurisdictionsListRequest,
  success: entityJurisdictionsListSuccess,
  failure: entityJurisdictionsListFailure,
} = entityJurisdictionsList.actions;

export default entityJurisdictionsList.reducer;
